/* eslint-disable react/no-multi-comp */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
    createOptionMessageResolver,
    convertFromKebabCase,
    TARGET_CASE,
} from '@ratehub/base-ui';

import INTENDED_USE_MESSAGES from '../definitions/IntendedUsageMessages';
import RATE_TERM_MESSAGES from '../definitions/RateTermMessages';
import RATE_TYPE_MESSAGES from '../definitions/RateTypeMessages';
import PAYMENT_FREQUENCY_MESSAGES from '../definitions/PaymentFrequencyMessages';


function createIntendedUsageOptionResolver(intl) {
    return createOptionMessageResolver(
        intl,
        Object.values(INTENDED_USE_MESSAGES),
        'Mortgages.intendedUsage.',
    );
}

function createYearOptionResolver({ formatMessage }) {
    return years => formatMessage(
        RATE_TERM_MESSAGES.TERM_IN_YEARS_MESSAGE,
        { years },
    );
}


function createRateTypeOptionResolver(intl) {
    return createOptionMessageResolver(
        intl,
        Object.values(RATE_TYPE_MESSAGES),
        'Mortgages.rateTypes.',
    );
}


function createPaymentFrequencyOptionResolver(intl) {
    return createOptionMessageResolver(
        intl,
        Object.values(PAYMENT_FREQUENCY_MESSAGES),
        'Mortgages.paymentFrequencies.',
    );
}


function createIsInsuredOptionResolver() {
    return isInsured => (
        <FormattedMessage
            id="mtg-common.is-insured-options"
            defaultMessage={'{isInsured, select, true {less than 20%} other {20% or more}}'}
            values={{
                isInsured,
            }}
        />
    );
}

function createRefinancePurposeOptionResolver() {
    return purpose => (
        <FormattedMessage
            id="mtg-common.refinance-purposes"
            defaultMessage={`{purpose, select, 
                accessHomeEquity {Access home equity}
                lowerInterestRate {Lower interest rate}
                consolidateDebt {Consolidate debt}
                other {Other}
            }`}
            values={{
                purpose: convertFromKebabCase(purpose, TARGET_CASE.camel),
            }}
        />
    );
}

export {
    createIntendedUsageOptionResolver,
    createRateTypeOptionResolver,
    
    // exporting separate symbols, but both use the same implementation
    createYearOptionResolver as createTermOptionResolver,
    createYearOptionResolver as createAmortizationOptionResolver,

    createPaymentFrequencyOptionResolver,
    createIsInsuredOptionResolver,
    createRefinancePurposeOptionResolver,
};
